module.exports = __webpack_public_path__ + "666a82cb3e9f8591bef4049aea26c4c6.svg";